import React from "react";
import filter from "../../assets/images/filter.svg";
import blueFilter from "../../assets/images/BlueFilterIcon.svg";

const DSBPScreenNameHeader = (options, frozenCoulmns, sortData, projectNameOnClick, selectedFields) => {
  let splittedCol = options?.split("_").join(" ");
  const isFilterActivated =
    (selectedFields && Object.keys(selectedFields)?.length && selectedFields[options]?.length>0);
    const isFrozen = frozenCoulmns?.includes(options);
  return (
    <div className={`flex-display ${isFrozen ? "font-bold frozen-width" : ""}`}>
      <>
        <img
          src={isFilterActivated ? blueFilter : filter}
          alt="Column Filter"
          className="columnFilterIcon"
          onClick={(e) => projectNameOnClick(e, options)}
        />
        <span className="columnFilterIcon">
          {splittedCol === "AWMProjectID" && "AWM Project"}
          {splittedCol === "DSBP InitiativeID" && "DSBP ID"}
          {splittedCol === "DSBP Initiative Name" && "DSBP Name"}
          {splittedCol === "Category" && "Category"}
          {splittedCol === "DSBP IL" && "IL"}
          {splittedCol === "CountOfLockedPMPs" && "Qty of PMPs"}
          {splittedCol === "CountOfPOAs" && "Qty of POAs"}
          {splittedCol === "Region" && "Region"}
          {splittedCol === "PM" && "Flow Leader"}

          {splittedCol !== "AWMProjectID" &&
            splittedCol !== "DSBP InitiativeID" &&
            splittedCol !== "DSBP Initiative Name" &&
            splittedCol !== "Category" &&
            splittedCol !== "DSBP IL" &&
            splittedCol !== "CountOfLockedPMPs" &&
            splittedCol !== "CountOfPOAs" &&
            splittedCol !== "Region" &&
            splittedCol !== "PM" &&
            splittedCol}
        </span>
      </>
    </div>
  );
};

export default DSBPScreenNameHeader;